import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In the early stages of her third pregnancy, Joyce Mihinzo was enrolled in the `}<a parentName="p" {...{
        "href": "https://insight.wfp.org/saving-lives-in-the-first-1-000-days-36a9caef633c"
      }}>{`Boresha Lishe`}</a>{` nutrition project in Maduma, a town in Central Tanzania. Boresha Lishe, meaning ‘better nutrition’ in Swahili, is funded by the EU and implemented by WFP and its partners.`}</p>
    <p>{`The programme ensures that children get adequate nutrition in the first 1,000 days of life. This period, between the time of conception and their second birthday, is vital for allowing brain development and optimum physical growth.`}</p>
    <p>{`Suffering from malnutrition, Joyce went into early labour at 36 weeks into her pregnancy. At the medical facility, she was supported with nutrition education and put on a special diet to help milk production. Within a few days, she was able to breastfeed her new-born daughter Tamari. The baby’s skin returned to its natural colour and she started gaining weight. At 6 months old, after exclusive breastfeeding, Tamari was then able to consume fortified porridge provided by WFP.`}</p>
    <p>{`“If it wasn’t for the fortified cereals I had once I got home, I don’t think my daughter would have recovered as quickly she did,” says Joyce. Meanwhile, Tamari has completed the Boresha Lishe 1,000-day cycle and is a happy, healthy toddler.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      